import { cloneDeep } from "lodash";
import { HierarchyContextProps, IHierarchyActionUpdateHierarchy } from "../interface";
import { hcr_updateChangedFlag } from "./hcr_updateChangedFlag";

/**
 * Applies editable hierarchy field updates.
 *
 * @param state - The current hierarchy context state.
 * @param action - The update-hierarchy action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_updateHierarchy = (
  state: HierarchyContextProps,
  action: IHierarchyActionUpdateHierarchy,
): HierarchyContextProps => {
  if (!state.hierarchy)
    throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);

  const newState: HierarchyContextProps = {
    ...state,
    hierarchy: {
      ...state.hierarchy,
      ...action.hierarchy,
    },
    isNameChanged:
      typeof action.isNameChanged === "boolean" ? action.isNameChanged : state.isNameChanged,
  };

  if (action.savedHierarchy) {
    newState.savedHierarchy = cloneDeep(action.savedHierarchy);
  }

  return hcr_updateChangedFlag(newState, action);
};
